var exports = {
  "J": "ProfileCardContent.module__contentSection___YVRwaG",
  "s": "ProfileCardContent.module__contentSectionWebhook___YVRwaG",
};

module.exports = exports;
